export const RUNNING_TIME_COLOR = {
  stoppedUndefined: 'warning.main',
  stoppedDefined: 'error.main',
  running: 'success.main',
  planned: 'grey.600'
}
